import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TransactionsComponent } from './transactions';
import { OffersComponent } from './offers.component';
import { SalesComponent } from './sales.component';
import { AccountsComponent } from './accounts.component';
import { TransactionAddComponent } from './transaction.add.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: 'transactions', component: TransactionsComponent, data: { title: 'Transactions' } },
    { path: 'sales', component: SalesComponent, data: { title: 'Sales' } },
    { path: 'offers', component: OffersComponent, data: { title: 'Offers' } },
    { path: 'accounts', component: AccountsComponent, data: { title: 'Accounts' } },
    { path: 'transactionadd', component: TransactionAddComponent, data: { title: 'Add Transaction' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class TransactionRoutingModule { }
